import React, { Fragment, ReactNode } from 'react';
import cx from 'classnames';
import { isNil } from 'lodash';
import './style';
import { ListBoxStyle } from './style';

interface ListBoxProps {
  className?: string;
  totalCnt?: number;
  head?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
}
const ListBox = (props: ListBoxProps) => {
  const { className, head, totalCnt, body, footer } = props;
  return (
    <ListBoxStyle className={cx('list-box', className)}>
      {head || !isNil(totalCnt) ? (
        <div className="list-box-head">
          <span className={cx('list-total-cnt', className)}>
            {!isNil(totalCnt) ? (
              <Fragment>
                <span>{totalCnt}</span>건이 조회되었습니다.
              </Fragment>
            ) : null}
          </span>

          {head}
        </div>
      ) : null}

      {body ? <div className="list-box-body">{body}</div> : null}

      {footer ? <div className="list-box-footer">{footer}</div> : null}
    </ListBoxStyle>
  );
};

export default ListBox;
